import { Component } from "~/ecs/base"

export class Bloom2 extends Component {
  static editor = {
    label: "Bloom Effect",
    description: 'Adds a pseudo light source "after effect" to bright colors.',
  }
}
